export default __webpack_public_path__ + "static/media/profileImage.8b52130f.svg";